import Vue from 'vue'
import VueAxios from 'vue-axios'
import Axios from 'axios';

import router from './utils/router'
import vuex from './utils/vuex'
import API from './utils/api'
import bus from './utils/bus'

import App from './App'

Vue.use(VueAxios, Axios)

// 全局筛选器-数字转换处理
Vue.filter('numberDisplay', function(value) {
    if (value === null || value === undefined || value === 'null' || value === 'undefined') {
        return '0'
    } else {
        return value
    }
})

// router预定义
router.beforeEach((to, from, next) => {
    if (!vuex.getters.isLogin()) {
        if (to.path.indexOf('/profile/') >= 0 && to.path !== '/profile/login') {
            next('/profile/login')
        } else {
            if (to.path.indexOf('/product/') >= 0) {
                next(false)
                bus.$emit('unlogin', { status: true })
            } else {
                next()
            }
        }
    } else {
        if (!vuex.getters.isCardValid()) {
            if (to.path === '/profile/identity') {
                next()
            } else {
                vuex.commit('invalidToken')
                next()
            }
        } else if (!vuex.getters.isTypeValid()) {
            if (to.path === '/profile/review') {
                next()
            } else {
                vuex.commit('invalidToken')
                next()
            }
        } else {
            next()
        }
    }
})

// 网络请求配置
Axios.defaults.baseURL = 'http://www.jdoor.cn' // 'http://www.jdoor.cn'
    // Axios.defaults.baseURL = 'http://192.168.16.115:8898' // 'http://www.jdoor.cn'
Axios.interceptors.request.use(function(config) {
    if (vuex.state.user.token) {
        config.headers['Authorization'] = `JWT ${vuex.state.user.token}`
    }
    return config
})

Axios.interceptors.response.use(function(resp) {
    return { data: resp.data }
}, function(error) {
    const response = error.response
    if (response.status === 403 || response.status === 401) {
        if (response.data) {
            if (response.data.error) {
                alert(response.data.error)
            } else {
                vuex.commit('invalidToken')
                router.replace('/')
                bus.$emit('unlogin', { status: true })
            }
        } else {
            vuex.commit('invalidToken')
            router.replace('/')
            bus.$emit('unlogin', { status: true })
        }
    } else {
        alert(error.message)
    }
    return Promise.reject(error.message)
})

Vue.config.productionTip = true
vuex.dispatch('fetchSite')

// 登录凭据
let token = localStorage.getItem('userToken')
if (token === null) {
    // token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6IjI6MToxNTI4MzU5OTI1MCIsIm9yaWdfaWF0IjoxNTIyMzA5NTIwLCJ1c2VyX2lkIjoxMzksImVtYWlsIjoiIiwiZXhwIjoxNTI3NDkzNTIwfQ.OdDy4FIohdxJiwgCJnItkErI8OLkAJtbgqg_OFUS5z0'
}
vuex.commit('updateUser', { token: token })
if (vuex.getters.isLogin()) {
    vuex.dispatch('fetchUser').then(() => {
        /* eslint-disable no-new */
        new Vue({
            el: '#app',
            router,
            store: vuex,
            template: '<app/>',
            components: { App }
        })
    })
} else {
    /* eslint-disable no-new */
    new Vue({
        el: '#app',
        router,
        store: vuex,
        template: '<app/>',
        components: { App }
    })
}


// WEBPACK FOOTER //
// ./src/main.js